import { Company } from './Company';
import { Enrollment } from './Enrollment';
import { Item } from './Item';
import { Role } from './Role';

export interface CommunicationPreferences {
  enableSms: boolean;
  enableEmail: boolean;
}

export const defaultCommunicationPreferences: CommunicationPreferences = {
  enableSms: false,
  enableEmail: true,
};

export interface Person extends Item {
  authId?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  sms?: string;
  lastSigninAt?: Date;
  companyId: number;
  company?: Company;
  lmsId?: string;
  sisId?: string;
  posId?: string;
  ltiId?: string;
  campusId?: string;
  imageUrl?: string;
  role?: Role;
  preferences: CommunicationPreferences;

  // Just used in the course code workflow
  enrollments?: Enrollment[];
}

export const displayPerson = (person?: Person | null): string => {
  if (!person) return '-';
  let name = person?.firstName ?? '';
  if (person?.lastName) {
    name += ' ' + person.lastName;
  }
  if (name.trim() === '') {
    return 'Not Given';
  }
  return name;
};

export interface PersonFilterList {
  companyId?: number;
  search?: string;
}

export const isPersonSaved = (person: Person): boolean => {
  return !!person.id;
};

export const getPersonInitials = (person: Person | null | undefined): string =>
  person
    ? `${person.firstName?.charAt(0) ?? ''}${person.lastName?.charAt(0) ?? ''}`.toUpperCase()
    : '';
